﻿import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {marked} from "marked";
import {JSX} from "react";

export default function PortalUnavailable(): JSX.Element {
	return (
		<section className="welcome full-layout full-layout--centered">
			<div dangerouslySetInnerHTML={{__html: marked(translation(PermitTranslations.features__portal_unavailable))}}></div>
		</section>
	)
}
